import React from "react";
import arrow from "../assets/images/sidom/fotos/FlechaenCirc4.png"; // Adjust the path as necessary

export default function CardProductos({ title, img, description, icon }) {
  return (
    <div className="bg-sidom-orange rounded-xl h-[400px] w-[320px] overflow-hidden shadow-lg hover:shadow-2xl ">
      <div className="relative ">
        <img src={img} alt={title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent">
          <div className="absolute bottom-4 ">
            <div className="flex px-12  w-full  flex-col items-start justify-start ">
              <div className="w rounded-full flex items-center justify-center">
                <img src={icon || arrow} className="w-8 h-8 " alt={title} />
              </div>
              <h2 className="text-xl font-bold text-white text-nowrap ">
                {title}
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="px-12   mt-[40px]">
        <p className="text-sidom-light  text-sm">{description}</p>
      </div>
    </div>
  );
}
